import { media } from '../../styles';
import styled from 'styled-components';

export const GlobeContainer = styled.button`
  background: none;
  border: none;
  height: 24px;
  min-width: 24px;
  padding: 0;
  width: 24px;

  &:focus-visible {
    outline-color: ${({ theme }) => theme.ui.text.color};
    outline-style: auto;
    outline-width: 5px;
  }
`;

type MenuContainerProps = {
  dropdownExpanded?: boolean;
};

export const MenuContainer = styled.div<MenuContainerProps>`
  align-items: center;
  border-radius: 4px;
  ${({ dropdownExpanded }) =>
    dropdownExpanded &&
    `box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 2px 4px -1px rgba(0, 0, 0, 0.2);`}
  display: flex;
  line-height: 18px;
  overflow: hidden;
  position: relative;
  z-index: 2147483643;
`;

type SelectorProps = {
  maxHeight?: number;
};

export const Menu = styled.div<SelectorProps>`
  display: flex;
  flex-direction: column;
  max-height: ${({ maxHeight }) => maxHeight || 100}px;
  min-width: 160px;
  overflow-y: auto;
  width: 100%;
`;

export const MenuItem = styled.button`
  align-items: center;
  background-color: white;
  border: 0;
  display: flex;
  font-size: ${({ theme }) => theme.typography.size.medium};
  margin: 0;
  outline: none;
  padding: ${({ theme }) => `${theme.spacing.base.sm} ${theme.spacing.base.md}`};
  text-align: left;
  justify-content: space-between;

  &:first-child {
    border-bottom: 1px solid #f4f4f4;
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.neutral.default};
  }

  ${media.mobilePortrait} {
    min-height: 35px;
  }
  ${media.mobileLandscape} {
    min-height: 35px;
  }

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const TextContainer = styled.div`
  font-weight: 600;
`;
